import type { PopupClient } from './popupManager';

const updatePopupQueue = () => {
    window.dispatchEvent(new Event('popupQueueUpdated'));
};

const getPopupQueue = () => {
    window.popupQueue = window.popupQueue ?? new Map();
    return window.popupQueue;
};

export const requestPopup = (id: PopupClient | string, successCb: () => void) => {
    getPopupQueue().set(id, { requestedPopup: true, successCb });
    updatePopupQueue();
};

export const noNeedForPopup = (id: PopupClient | string) => {
    getPopupQueue().set(id, { requestedPopup: false });
    updatePopupQueue();
};
